import PropTypes from 'prop-types'
import React from 'react'
import classes from './Products.scss'
import Button from 'components/Button'
import List from 'components/BetterList'

export class Products extends React.Component {
  getRowLink = product => {
    return `/products/${product.id}/edit`
  };

  getRowColumns = (product, index, array) => {
    return [
      product.name,
      product.type && product.type.name,
      product.category && product.category.name,
      !product.customers || !product.customers.length && '' ||
        product.customers.length > 1 && product.customers.length ||
        (product.customers.find(o => o.name) || {}).name
    ]
  };

  render () {
    return (
      <div className={classes['collection']}>
        <header className={classes['header']}>
          <div className={classes['header-title']}>
            Browsing Products
            <span className={classes['header-title--unimportant']}> – {this.props.products.length}</span>
          </div>

          <div className={classes['header-buttons']}>
            <Button options={['green', 'small']} element='a' href='/products/new'>
              Add Product
            </Button>
          </div>
        </header>

        <List
          collection={this.props.products}
          headers={['name', 'type', 'category', 'customers']}

          getRowLink={this.getRowLink}
          getRowColumns={this.getRowColumns}

          sort={'name'}
          filter={[
            'name', 'scientific_name', 'details', 'customer.name',
            'tasting_notes', 'fishing_vessel', 'sourcing_method', 'sourcing_location',
            'type.name', 'category.name'
          ]}
          filterPlaceholder='search products'
        />
      </div>
    )
  }
}

Products.propTypes = {
  categories: PropTypes.array,
  customers: PropTypes.array,
  products: PropTypes.array.isRequired,
  types: PropTypes.array.isRequired
}

Products.defaultProps = {
  categories: [],
  customerss: [],
  products: [],
  types: []
}

export default Products



// WEBPACK FOOTER //
// ./src/components/Products/Products.js